import EpgEvent from '../../classes/epgEvent';
import Pages from '@pages';
import Services from '../../types/enums/services';
import { EventMap } from '@shared/types/interfaces/event';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { reset, setLive, setRange, setTimeshift } from '../slices/media.slice';
import { updateEvent } from '../slices/channels.slice';
import {
  IChannelsState,
  IEventsState,
  IRouteState,
} from '../../types/interfaces/states';
import {
  loadEvents as loadEventsAction,
  loadMockedEvents as loadMocksAction,
  updateEvents as updateEventsAction,
} from '../slices/events.slice';

const loadEvents = createAsyncThunk('load/events', (data: EventMap, thunk) => {
  try {
    const { channels, router } = thunk.getState() as {
      channels: IChannelsState;
      router: IRouteState;
    };
    const mocks =
      channels.channelsData?.map((item) => {
        return new EpgEvent({
          actors: [],
          channel: item.id,
          mocked: true,
          synopsisLong: item.fake.longDescription || item.fake.shortDescription,
          title: item.fake.eventName,
        });
      }) || [];
    thunk.dispatch(
      loadEventsAction({
        events: data,
        purge: router.route.Page !== Pages.ZAPPER,
      })
    );
    thunk.dispatch(loadMocksAction(mocks));
    thunk.dispatch(updateEvents(false));
  } catch (error) {
    thunk.rejectWithValue(error);
  }
});

const getNextEvent = createAsyncThunk(
  'get/nextEvent',
  (event: EpgEvent | null | undefined, thunk) => {
    if (!event) {
      thunk.dispatch(updateCurrentEvent());
      return;
    }
    try {
      const { channels, events } = thunk.getState() as {
        channels: IChannelsState;
        events: IEventsState;
      };
      const channelIndex = channels?.currentChannel?.id;
      if (channelIndex) {
        if (event) {
          const nextEventIndex =
            events.eventsData[channelIndex].indexOf(event) + 1;
          const nextEvent =
            nextEventIndex < events.eventsData[channelIndex].length
              ? events.eventsData[channelIndex][nextEventIndex]
              : events.currentEvents[channelIndex] || event;
          thunk.dispatch(setRange({ event: nextEvent?.date }));
          thunk.dispatch(updateEvent(nextEvent));
        }
      }
    } catch (error) {
      thunk.rejectWithValue(error);
    }
  }
);

const updateCurrentEvent = createAsyncThunk(
  'update/event',
  (_data: undefined, thunk) => {
    try {
      const { channels, events, router } = thunk.getState() as {
        channels: IChannelsState;
        events: IEventsState;
        router: IRouteState;
      };
      const channelIndex = channels?.currentChannel?.id;
      const currentChannel = channels?.currentChannel;
      if (channelIndex) {
        const currentEvent = events.currentEvents[channelIndex];
        const timeshift = currentChannel?.services.includes(Services.TIMESHIFT);
        router.route.Page === Pages.ZAPPER && thunk.dispatch(setLive());
        thunk.dispatch(setRange({ event: currentEvent?.date }));
        thunk.dispatch(setTimeshift(timeshift || false));
        thunk.dispatch(updateEvent(currentEvent));
      }
    } catch (error) {
      thunk.rejectWithValue(error);
    }
  }
);

const updateEvents = createAsyncThunk(
  'update/events',
  (shouldUpdateCurrentEvent: boolean | undefined, thunk) => {
    try {
      thunk.dispatch(updateEventsAction());
      if (shouldUpdateCurrentEvent) {
        thunk.dispatch(updateCurrentEvent());
        thunk.dispatch(reset());
      }
    } catch (error) {
      thunk.rejectWithValue(error);
    }
  }
);

export { loadEvents, getNextEvent, updateCurrentEvent, updateEvents };
